var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.01777 7.63636L9.63388 1.8623C10.122 1.43627 10.122 0.745546 9.63388 0.31952C9.14573 -0.106507 8.35427 -0.106507 7.86612 0.31952L0.366117 6.86497C-0.122039 7.291 -0.122039 7.98173 0.366117 8.40775L7.86612 14.9532C8.35427 15.3792 9.14573 15.3792 9.63388 14.9532C10.122 14.5272 10.122 13.8365 9.63388 13.4104L3.01777 7.63636Z",
    fill: "#3EB0CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBlue);
export default __webpack_public_path__ + "static/media/back_blue.a9b1609388190350cc9067e6ebaa8e20.svg";
export { ForwardRef as ReactComponent };